<template>
<div>
    <!--:::::::::::::::::::::::::::::::::::::::::::::
        FixedLogo
    :::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="md_fixed-logo" v-bind:class="{_white:(openMenuHmbrg || openSearch)}">
        <div class="logo">
            <a href="/"><SvgLogoAuma /></a>
        </div>
        <div class="copy">
            <span>さがす・つながる・ひろがる。</span>
        </div>
    </div>

    <!--:::::::::::::::::::::::::::::::::::::::::::::
        DrawerMenu
    :::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="menu_hmbg-container">

        <!--btn-->
        <button class="hmbg-button" v-bind:class="{_open:openMenuHmbrg, _white:openSearch, _searchActive:openSearch}">
            <div class="inner _default" v-on:click="openMenuHmbrg=!openMenuHmbrg">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="inner _hover" v-on:click="openMenuHmbrg=!openMenuHmbrg">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="inner _close" v-on:click="closeMenuAll">
                <span></span>
                <span></span>
            </div>
        </button><!--/.btn-->

        <!--menu-->
        <nav class="hmbg-menu" v-bind:class="{_searchActive:openSearch}">
            <div class="md_scroll-content">
                <div class="inner">

                    <!--PageMenu-->
                    <div class="group">
                        <div class="heading_line">
                            <p><span>Menu</span></p>
                            <div class="line"></div>
                        </div>
                        <ul class="page">
                            <MenuLinkListStatic />
                        </ul>
                    </div>

                    <!--SnsMenu-->
                    <div class="group">
                        <div class="heading_line">
                            <p><span>OFFICIAL SNS</span></p>
                            <div class="line"></div>
                        </div>
                        <ul class="sns">
                            <li><a href="https://www.facebook.com/profile.php?id=100088439449342" target="_blank"><div class="md_svg-icon"><SvgIconSnsFacebook /></div></a></li>
                            <li><a href="https://twitter.com/AUMA_official" target="_blank"><div class="md_svg-icon _small"><SvgIconSnsTwitter /></div></a></li>
                            <li><a href="https://www.instagram.com/auma.official/" target="_blank"><div class="md_svg-icon"><SvgIconSnsInstagram /></div></a></li>
                            <li><a href="https://lin.ee/s3UOfUY" target="_blank"><div class="md_svg-icon"><SvgIconSnsLine /></div></a></li>
                        </ul>
                    </div>

                </div>
            </div>
        </nav><!--/.menu-->

    </div><!--/.menu_hmbg-container-->

    <!--:::::::::::::::::::::::::::::::::::::::::::::
        SearchMenu
    :::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="menu_search-container" v-bind:class="{_none:(openMenuHmbrg || openSearchDelayClass), _open:openSearchDelayClass, _show:openSearchBlock}">

        <button v-if="$store.state.search.set.user" type="button" class="md_icon-btn _menu-open" v-on:click="logout()">
            <div class="inner"><SvgIconLogout /></div>
        </button>

        <button v-else type="button" class="md_icon-btn _menu-open" v-on:click="logout()">
            <div class="inner"><SvgIconLogin /></div>
        </button>

        <button type="button" class="btn_floating-action" v-on:click="openSearchClick()">
            <div class="btn_floating-action-body">
                <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="41.553" cy="37.5531" r="22.3114" transform="rotate(-45 41.553 37.5531)" stroke="#000000" stroke-width="4"></circle><path d="M57.33 53.3291L59.0625 55.0615M59.5956 55.5946L59.0625 55.0615M64.9262 60.9252L59.0625 55.0615" stroke="#000000" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M79 75L72.1343 68.1343M71.5565 67.5565L72.1343 68.1343M65.7785 61.7785L72.1343 68.1343" stroke="#000000" stroke-width="7" stroke-linecap="square"></path></svg>
            </div>
        </button>

        <div class="search-menu-wrap">

            <!--TabSelector-->
            <div class="tab-selector-wrap">
                <div v-if="!pageShowroom" :class="[tabSelectorActive === 1 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 1;">
                    <span>
                        <label for="search-select1"><span>価格軸</span></label>
                    </span>
                </div>
                <div :class="[tabSelectorActive === 2 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 2;">
                    <span>
                        <label for="search-select2"><span>カテゴリー</span></label>
                    </span>
                </div>
                <div :class="[tabSelectorActive === 3 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 3;">
                    <span>
                        <label for="search-select3"><span>こだわり条件</span></label>
                    </span>
                </div>
                <div v-if="$store.state.search.form.shop_user_plan == 11" :class="[tabSelectorActive === 4 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 4;"><!-- unit-->
                    <span>
                        <label for="search-select4"><span>ハッシュタグ</span></label>
                    </span>
                </div>
                <div :class="[tabSelectorActive === 5 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 5;">
                    <span>
                        <label for="search-select5"><span>保存した検索条件</span></label>
                    </span>
                </div>
                <div :class="[tabSelectorActive === 6 ? '_active' : '', 'grid _select']" v-on:click="tabSelectorActive = 6;">
                    <span>
                        <label for="search-select6" v-on:click="searchFocus"><span>フリーワード</span></label>
                    </span>
                </div>
            </div>

            <!--:::::::::::::::::::::::::::::::::::::::::::::
                TabContents
            :::::::::::::::::::::::::::::::::::::::::::::-->
			<div class="search-contents-container">

                <template v-if="!pageShowroom">
                    <!--価格軸から検索 :::::::::::::::::::::::::::::::::::::::::::::-->
                    <input type="radio" name="search-select" class="" id="search-select1" value="" checked>
                    <MenuSearchValue />
                    <!--カテゴリーから探す :::::::::::::::::::::::::::::::::::::::::::::-->
                    <input type="radio" name="search-select" class="_category" id="search-select2" value="" >
                    <MenuSearchCategory />
                </template>

                <template v-if="pageShowroom">
                    <!--カテゴリーから探す :::::::::::::::::::::::::::::::::::::::::::::-->
                    <input type="radio" name="search-select" class="_category" id="search-select2" value="" checked>
                    <MenuSearchCategory />
                </template>

                <!--こだわり条件 :::::::::::::::::::::::::::::::::::::::::::::-->
                <input type="radio" name="search-select" class="" id="search-select3" value="" >
                <MenuSearchParticular />

                <!--ハッシュタグ :::::::::::::::::::::::::::::::::::::::::::::-->
                <input type="radio" name="search-select" class="" id="search-select4" value="" >
                <MenuSearchHashTags />

                <!--保存した検索条件 :::::::::::::::::::::::::::::::::::::::::::::-->
                <input type="radio" name="search-select" class="" id="search-select5" value="" >
                <MenuSearchSavedCriteria />

                <!--フリーワード :::::::::::::::::::::::::::::::::::::::::::::-->
                <input type="radio" name="search-select" class="" id="search-select6" value="" >
                <MenuSearchFreeWord />

			</div>

        </div><!-- /.search-menu-wrap -->

        <!--SearchButton-->
        <button type="button" class="search-execution" v-on:click="brandSearch()">
            <div class="md_icon-btn">
                <div class="inner"><SvgIconSearch /></div>
            </div>
            <div class="text">
                <span>{{searchName}} SEARCH</span>
            </div>
        </button>

    </div><!-- /.menu_search-container -->

    <!--:::::::::::::::::::::::::::::::::::::::::::::
        MySelectRoomButton
    :::::::::::::::::::::::::::::::::::::::::::::-->
    <a
        v-if="$store.state.search.set.user"
        v-bind:href="linkToMySelectRoom"
        type="button"
        class="md_icon-btn _my-select-room menu_my-select-room-container btn_svg-icon" v-bind:class="{ _notice: 0 < sum_read }">
        <div class="inner"><SvgIconShop /></div>
    </a>

    <!-- /MySelectRoomButton -->


    <!--:::::::::::::::::::::::::::::::::::::::::::::
        Curtain
    :::::::::::::::::::::::::::::::::::::::::::::-->
    <div class="md_curtain-container" v-bind:class="{_open:(openMenuHmbrg || openSearch)}"><div class="no1"></div><div class="no2"></div><div class="no3"></div></div>
</div>
</template>

<script>
    import SvgLogoAuma from '@/components/EndUser/svg/SvgLogoAuma'

    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconShop from '@/components/EndUser/svg/SvgIconShop'

    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconSnsLine from '@/components/EndUser/svg/SvgIconSnsLine'
    import SvgIconLogin from '@/components/EndUser/svg/SvgIconLogin'
    import SvgIconLogout from '@/components/EndUser/svg/SvgIconLogout'

    //SearchParts
    import MenuSearchValue from '@/components/EndUser/MenuSearchValue'
    import MenuSearchCategory from '@/components/EndUser/MenuSearchCategory'
    import MenuSearchParticular from '@/components/EndUser/MenuSearchParticular'
    import MenuSearchSavedCriteria from '@/components/EndUser/MenuSearchSavedCriteria'
    import MenuSearchHashTags from '@/components/EndUser/MenuSearchHashTags'
    import MenuSearchFreeWord from '@/components/EndUser/MenuSearchFreeWord'

    //LinkList
    import MenuLinkListStatic from '@/components/EndUser/MenuLinkListStatic'

    import commonMixins from '@/common/utility.js'

    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    export default {
        mixins: [commonMixins],
        components: {
            SvgLogoAuma,
            //SvgIcon
            SvgIconShop,
            SvgIconSearch,
            SvgIconLogin,
            SvgIconLogout,
            //SvgIconSns
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
            SvgIconSnsLine,
            //MenuSearchParts
            MenuSearchValue,
            MenuSearchCategory,
            MenuSearchParticular,
            MenuSearchSavedCriteria,
            MenuSearchHashTags,
            MenuSearchFreeWord,
            //MenuLinkList
            MenuLinkListStatic,
        },
        data: {
            tabSelectorActive: 1,
            openMenuHmbrg: false,
            openSearch: false,
            openSearchBlock: false,
            openSearchDelayClass: false,
            linkToMySelectRoom: '',
            sum_read: 0,
        },
        computed: {
            getPlan() {
                var url = this.$store.state.search.set.user.shop_user_plan;
                if (this.$store.state.search.set.user != -1) {
                    return 'ブランド';
                } else if (url.indexOf( 'shop' ) != -1) {
                    return 'ショップ';
                }
            },
            pageShowroom() {
                return location.pathname == '/showroom-list';
            },
            searchName() {
                if (location.pathname == '/showroom-list') {
                    return 'SHOWROOM';
                } else {
                    return 'BRAND';
                }
            },
        },
        methods: {

            ////////////////////////////////////
            // 開いているメニューを全て閉じる
            ////////////////////////////////////
            closeMenuAll: function () {
                this.openMenuHmbrg = false;
                this.openSearchDelayClass = false;
                this.openSearch = false;
                setTimeout(()=> {
                    this.openSearchBlock = false;
                }, 600);
            },

            ////////////////////////////////////
            //検索メニューでフリーワードを選択した場合、該当 input にフォーカスさせる
            ////////////////////////////////////
            searchFocus: function () {
                document.getElementById('free-word').focus();
            },

            window: onload = function () {
                ////////////////////////////////////
                //ウィンドウサイズが1024px以下の場合、検索を開いた時に何も選択していない状態にする
                ////////////////////////////////////
                const mediaQuery = window.matchMedia('(max-width: 1024px)');
                handle(mediaQuery);
                mediaQuery.addEventListener(handle, () => {
                });
                function handle(mm) {
                    if (mm.matches) {
                        for (const element of document.getElementsByName('search-select')) {
                            element.checked = false;
                        }
                    } else {
                        // それ以外の処理
                    }
                }
            },
            openSearchClick() {
                this.openSearch = true;
                setTimeout(()=> {
                    this.openSearchBlock = true;
                }, 0);
                setTimeout(()=> {
                    this.openSearchDelayClass = true;
                }, 600);
            },
            login() {
                location.href = route('login');
            },
            logout() {
                location.href = route('logout');
            },

            brandSearch() {
                // var formData = this.$store.state.search.form;
                // var jsontext = JSON.stringify(formData)

                // var form = document.createElement('form');
                // form.action = '/brand-list';
                // form.method = 'POST';

                // var q = document.createElement('input');
                // q.value = jsontext;
                // q.name = 'form';
                // form.appendChild(q);

                // var csrf = document.createElement('input');
                // var token = $('[name="csrf-token"]').attr('content');
                // csrf.type = 'hidden';
                // csrf.name = '_token';
                // csrf.value = token;
                // form.appendChild(csrf);
                // document.body.appendChild(form);
                // form.submit();

                if (location.pathname == '/showroom-list') {
                    var url = '/showroom-list';
                } else {
                    var url = '/brand-list';
                }

                this.$store.state.search.form.sales_recruitment_b = this.changeId(this.$store.state.search.form.sales_recruitment_b);
                this.$store.state.search.form.order = this.changeId(this.$store.state.search.form.order);
                this.$store.state.search.form.sales_style = this.changeId(this.$store.state.search.form.sales_style);
                this.$store.state.search.form.pay_rule = this.changeId(this.$store.state.search.form.pay_rule);
                this.$store.state.search.form.areaLv2 = this.changeId(this.$store.state.search.form.areaLv2);
                this.$store.state.search.form.areaLv3 = this.changeId(this.$store.state.search.form.areaLv3);
                this.$store.state.search.form.categoriyLv3 = this.changeId(this.$store.state.search.form.categoriyLv3);
                if (this.$store.state.search.form.categoriyLv2 != 0) {
                    var categoriyLv2s = [];
                    for(var i in this.$store.state.search.form.categoriyLv2) {
                        if (this.$store.state.search.form.categoriyLv2[i].first_category_id != 1) {
                            categoriyLv2s.push(this.$store.state.search.form.categoriyLv2[i].id);
                        }
                    }
                    this.$store.state.search.form.categoriyLv2 = categoriyLv2s;
                }

                const form = reactive({
                    search_form: this.$store.state.search.form,
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        location.reload();
                    },
                })
            },
            changeId (form_tests) {
                if (form_tests != 0) {
                    var ids = [];
                    for(var i in form_tests) {
                        var form_test = form_tests[i];
                        ids.push(form_test.id)
                    }
                    form_tests = ids;
                    return ids;
                }
            },
            getMenuAssets () {
                axios.get('/menu_assets',{
                }).then((res)=>{
                    this.$store.state.search.set.user = res.data.user;
                    this.$store.state.search.set.price_zone = res.data.price_zone;
                    this.$store.state.search.set.sales_recruitment = res.data.sales_recruitment;
                    this.$store.state.search.set.sales_style = res.data.sales_style;
                    this.$store.state.search.set.order = res.data.order;
                    this.$store.state.search.set.pay_rule = res.data.pay_rule;
                    this.$store.state.search.set.area_region = res.data.area_region;
                    this.$store.state.search.set.hashtags = res.data.hashtags;
                    this.$store.state.search.set.categories = res.data.categories;
                    this.$store.state.search.set.areas = res.data.areas;
                    this.$store.state.search.form.shop_user_plan = res.data.shop_user_plan;
                    this.sum_read = res.data.chat_read_sum;

                    // ログインの有無
                    if (this.$store.state.search.set.user) {
                        switch (this.$store.state.search.set.user.type) {
                            case 0:
                                this.linkToMySelectRoom = '/admin/news';
                                break;
                            case 1:
                                this.linkToMySelectRoom = '/admin/shop/news';
                                break;
                            case 2:
                                this.linkToMySelectRoom = '/admin/brand/dashboard';
                                // TODO: ユーザ情報により、リンクを変える
                                // 'admin.brand.dm.list'

                                break;
                            case 3:
                                this.linkToMySelectRoom = '/admin/showroom/dashboard';
                                break;
                        }
                        if (res.data.search_history) {
                            this.$store.state.search.set.search_history = res.data.search_history;
                        }
                    } else {
                        var forms = JSON.parse(localStorage.getItem('forms')) || [];
                        this.$store.state.search.set.search_history = forms;
                        this.linkToMySelectRoom = '/login'
                    }
                })
            }
        },
        mounted: function() {
            //ScrollTarget --------------------
            this.jsScrollTargets();
            //CursorFollower --------------------
            this.cursorFollower();

            this.getMenuAssets();

            console.log('user');
            console.log(this.$store.state.search.set.user);

            if (location.pathname == '/showroom-list') {
                this.tabSelectorActive = 2;
            } else {
                this.tabSelectorActive = 1;
            }
        },
    }
</script>
